import useSWR from "swr/immutable"

import { HasIdDisplay } from "~/@shared/api-types/id-name-display"
import { SuccessInfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

export type GetMasterSchools = SuccessInfraResponse<Array<MasterSchoolsData>>

export type MasterSchoolsData = HasIdDisplay & {
  school_type_id: number
  reading: string
}

const PATH = "/master/schools"

export const fetchGetMasterSchools = defineFetcher((): Promise<GetMasterSchools> => {
  return GET(PATH)
})

export const useSWRForGetMasterSchools = () => {
  return useSWR(PATH, fetchGetMasterSchools)
}
